import React, { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import AppConfig from '../../config/AppConfig';
import { getStorage } from '../../helpers/Storage';
import palette from '../../theme/gcbPalette';
const apiKey = AppConfig.get('REACT_APP_API_KEY');

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

interface Props {
  pdf?: string;
}

const RenderDocument = ({ pdf }: Props) => {
  const [numPages, setNumPages] = useState<number>();

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <div className="w-full">
      <div
        style={
          {
            scrollbarColor: `${palette.primary.medium} ${palette.neutral.light}`,
            scrollbarWidth: 'thin',
          } as React.CSSProperties
        }
        className="h-[552px] overflow-y-scroll [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-neutral-light [&::-webkit-scrollbar-track]:rounded-[10px] [&::-webkit-scrollbar-thumb]:bg-primary [&::-webkit-scrollbar-thumb]:rounded-[10px]"
      >
        <Document
          file={{
            url: pdf,
            httpHeaders: { apiKey: apiKey, authorization: `Bearer ${getStorage('token')}` },
          }}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(error) => console.error('Erro no carregamento do documento', error)}
          loading="Carregando contrato."
          noData="Contrato não encontrado."
        >
          {numPages &&
            Array.from(new Array(numPages), (_el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} height={800} />
            ))}
        </Document>
      </div>
    </div>
  );
};

export default RenderDocument;
